<template>
  <div class="page article content" data-cy="article-detail">
    <slot> </slot>
  </div>
</template>
<style lang="scss" scoped>
  .article {
    max-width: 80ch;

    a {
      text-decoration: underline;
    }

    > * + * {
      margin-top: $spacer20;
    }
  }

  .message {
    margin-bottom: $spacer20;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.15s ease-out;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
    transform: translateY(-50%);
  }
</style>
